<template>
  <NuxtLink v-if="data.link" class="nav-link" :to="path">
    {{ data.linkText ? data.linkText : data.link.title }}
  </NuxtLink>
</template>

<script setup lang="ts">
import type { NavigationLinkFragment } from '#gql';
import { useInternalRoute } from '~/datocms/useInternalRoute';

const props = defineProps<{
  data: NavigationLinkFragment;
}>();

const { path } = useInternalRoute(props.data.link);
</script>

<style scoped lang="scss">
.nav-link {
  text-decoration: none;
  color: var(--base-color-foreground);
}
</style>
